import {create} from "zustand"

interface SelectedExpertState {
  expertId: string
  setExpertId: (value: string) => void
  clearExpertId: () => void
  originFrom: string
  setOriginFrom: (value: string) => void
  displayExpert: boolean
  setDisplayExpert: (value: boolean) => void
  showFindExpert: boolean
  setShowFindExpert: (value: boolean) => void
}

const useExpertBioStore = create<SelectedExpertState>((set) => ({
  expertId: "",
  setExpertId: (value: string) => set({expertId: value}),
  clearExpertId: () => set({expertId: ""}),
  originFrom: "",
  setOriginFrom: (value: string) => set({originFrom: value}),
  displayExpert: false,
  setDisplayExpert: (value: boolean) => set({displayExpert: value}),
  showFindExpert: false,
  setShowFindExpert: (value: boolean) => set({showFindExpert: value}),
}))

export default useExpertBioStore
